












































import Vue from 'vue'
import FullModalHeader from '@/components/modal/basics/FullModal/FullModalHeader/FullModalHeader.vue'
import FullModalHeaderCloseButton from '@/components/modal/basics/FullModal/FullModalHeader/FullModalHeaderCloseButton.vue'
import GFooter from '@/components/globals/GFooter.vue'

export default Vue.extend({
  components: {
    FullModalHeader,
    FullModalHeaderCloseButton,
    GFooter,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    contentTransition: {
      type: Object,
      default: () => {
        return {
          name: 'modal-content',
        }
      },
    },
    withoutBorder: {
      type: Boolean as () => boolean,
      default: false,
    },
    withoutBackdrop: {
      type: Boolean as () => boolean,
      default: false,
    },
    contentClass: {
      type: String as () => string,
      default: '',
    },
  },
  methods: {
    onBeforeClose() {
      this.$emit('before-close')

      // NOTE: モーダルを閉じる時にvue-thin-modalのコンテナのスクロール位置を一番上にする
      // @see https://github.com/ktsn/vue-thin-modal/blob/master/src/components/ModalContent.js#L32
      const $modalContainer = document.querySelector(
        '.modal-wrapper .modal-content-wrapper'
      )
      if (!$modalContainer) return

      $modalContainer.scrollTop = 0
    },
  },
})
